const REQUEST_CHANGE_SAVED_REPORTS_FILTER = 'REQUEST_CHANGE_SAVED_REPORTS_FILTER'
const READY_CHANGE_SAVED_REPORTS_FILTER = 'READY_CHANGE_SAVED_REPORTS_FILTER'

const requestChangeSavedReportsFilterAction = () => {
  return {
    type: REQUEST_CHANGE_SAVED_REPORTS_FILTER
  }
}

const responseChangeSavedReportsFilterAction = (page) => {
  return {
    type: READY_CHANGE_SAVED_REPORTS_FILTER,
    page
  }
}

const handleChangeSavedReportsFilter = (page) => {
  return (dispatch) => {
    dispatch(requestChangeSavedReportsFilterAction())
    setTimeout(() => { dispatch(responseChangeSavedReportsFilterAction(page)) }, 10)
  }
}

export {
  handleChangeSavedReportsFilter,
  requestChangeSavedReportsFilterAction,
  responseChangeSavedReportsFilterAction,
  REQUEST_CHANGE_SAVED_REPORTS_FILTER,
  READY_CHANGE_SAVED_REPORTS_FILTER,
}
